import { createSlice } from "@reduxjs/toolkit";
import { fetchCapitalBalance, fetchCapitalAccountsBySearch } from "./capitalBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  capitalAccounts: [],
  capitalAccountsLoading: false,
  balanceTotal: 0,
  filters: {
    filterType: "All Capital Account",
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const capitalBalanceSlice = createSlice({
  name: "capitalBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCapitalBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCapitalBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.capitals || [];
        state.balanceTotal = action.payload.total_balance || 0;
      })
      .addCase(fetchCapitalBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchCapitalAccountsBySearch.pending, (state) => {
        state.capitalAccountsLoading = true;
      })
      .addCase(fetchCapitalAccountsBySearch.fulfilled, (state, action) => {
        state.capitalAccountsLoading = false;
        state.capitalAccounts = action.payload;
      })
      .addCase(fetchCapitalAccountsBySearch.rejected, (state) => {
        state.capitalAccountsLoading = false;
        state.capitalAccounts = [];
      });
  },
});

export const { setFilters } = capitalBalanceSlice.actions;
export default capitalBalanceSlice.reducer;
